import { render, staticRenderFns } from "./components_list.vue?vue&type=template&id=4ba22381"
import script from "./components_list.vue?vue&type=script&lang=js"
export * from "./components_list.vue?vue&type=script&lang=js"
import style0 from "./components_list.vue?vue&type=style&index=0&id=4ba22381&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports